var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"services__wrapper"},[_vm._l((_vm.avaliableServices),function(service){return [(!service.needLogin || _vm.isLogged)?_c('service-item',{key:service.title,attrs:{"service":service}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }